import { IService, ServiceType } from "../../ServiceManager";
import { Logger, LogLevel } from "../../Logger";
import { FirebaseConfig } from "./Config";

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
import "firebase/firebase-messaging";
import { FirebaseMessage, FirebaseMessageData, FirebaseMessageDataType } from "./Message";
import { NewListingMessageData } from "./MessageTypes/NewListingMessage";
import { ListingPriceChangeMessageData } from "./MessageTypes/ListingPriceChangeMessage";
import { NewBlogPostMessageData } from "./MessageTypes/NewBlogPostMessage";
import { Eventable } from "../../../util";


interface FirebaseMessageDelegate {
  OnMessage(message: FirebaseMessageData): void;
}

class Firebase extends Eventable implements IService {
  Type: ServiceType = ServiceType.Firebase;
  Id: string = 'Firebase';

  Config: FirebaseConfig;
  private messaging: firebase.messaging.Messaging;

  constructor(config: FirebaseConfig) {
    super();

    this.Config = config;

    window.firebase = firebase;

    firebase.initializeApp(config.Config);

    this.messaging = firebase.messaging();

    this.messaging.usePublicVapidKey(this.Config.VAPIDKey);

    Logger.Log(LogLevel.Debug, '[Firebase]', 'Initialised Firebase');
  }

  Subscribe(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.messaging.getToken().then((token) => {
        resolve(token);

        this.Trigger('subscribed', token);
      }).catch(reject);
    });
  }

  Unsubscribe(): Promise<boolean> {
    this.Trigger('unsubscribed');

    return this.messaging.deleteToken();
  }

  SetBackgroundMessageDelegate(delegate: FirebaseMessageDelegate) {
    this.messaging.onBackgroundMessage((message) => {
      delegate.OnMessage(this.ResolveMessageType(this.ParseBackgroundMessage(message)));
    });
  }

  SetForegroundMessageDelegate(delegate: FirebaseMessageDelegate) {
    this.messaging.onMessage((message) => {
      delegate.OnMessage(this.ResolveMessageType(message));
    });
  }

  private ParseBackgroundMessage(payload: firebase.messaging.MessagePayload): FirebaseMessage {
    var data: any = {};

    if(payload.data) {
      var payloadKeys = Object.keys(payload.data);

      for(var i = 0; i < payloadKeys.length; i++) {
        data[payloadKeys[i]] = payload.data[payloadKeys[i]];
      }
    }

    return {
      data: data
    } as FirebaseMessage;
  }

  private ResolveMessageType(message: FirebaseMessage): FirebaseMessageData {
    switch(message.data.type) {
      case FirebaseMessageDataType.NewListing:
        return message.data as NewListingMessageData;
      case FirebaseMessageDataType.ListingPriceChange:
        return message.data as ListingPriceChangeMessageData;
      case FirebaseMessageDataType.NewBlogPost:
        return message.data as NewBlogPostMessageData;
      case FirebaseMessageDataType.Generic:
      default:
        return message.data;
    }
  }
}

export { Firebase, FirebaseMessageDelegate }
